import Vue from 'vue';
import App from './App.vue';
import router from './router';
import '@/plugins/axios';
import '@/plugins/buefy';
import '@/plugins/firebase';
import '@/plugins/vcalendar';
import 'v-credit-card/dist/VCreditCard.css';
import store from '@/state/store';
import '@/assets/scss/pandora-style.scss';
import '@mdi/font/css/materialdesignicons.css';
import { firebase, auth } from '@/plugins/firebase';

Vue.config.productionTip = false;
auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);

// eslint-disable-next-line no-unused-vars
auth.onAuthStateChanged(user => {
  new Vue({
    router,
    store,
    async created() {
      if (!user) return;

      // redirect to user/created if email not verified
      if (!user.emailVerified && !this.$route.path.includes('signup')) {
        this.$router.push('/user/created');
      }

      const { uid, email } = user;
      await store.dispatch('auth/initStore', {
        uid,
        email
      });

      try {
        await store.dispatch('user/loadUserDoc', uid);
      } catch (err) {
        console.error(err);
        this.$router.push('/signup');
        return;
      }

      // redirect to sign up page if can't load userDoc

      await store.dispatch('doron/initStore', uid);

      const userState = store.state.user;
      if (
        userState.userType === 'performer' &&
        !userState.ivsChannelArn &&
        !userState.ivsStreamKeyArn
      ) {
        console.log('Create new ivs channel...');
        await store.dispatch('createChannel', uid);
      } else if (
        userState.userType === 'performer' &&
        userState.ivsChannelArn &&
        userState.ivsStreamKeyArn
      ) {
        await store.dispatch('ivs/initStore', {
          channelArn: userState.ivsChannelArn,
          streamKeyArn: userState.ivsStreamKeyArn
        });
      }
    },
    render: h => h(App)
  }).$mount('#app');
});
